import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  editNoteButtonContainer: {
    marginTop: theme.spacing(2.5),
    marginBottom: theme.spacing(2),
    maxWidth: '7.71em',
  },
  noteCard: {
    whiteSpace: 'pre-line',
    marginBottom: theme.spacing(1),
    padding: `${theme.spacing(0.5)}px 0`,
    '&:last-child': {
      marginBottom: 0,
    },
  },
}))

export default useStyles
